<template>
    <v-select
        @input="input"
        :options="options"
        :value="value"
        :name="name"
        :label="label"
        :placeholder="placeholder"
        :multiple="multiple"
        :taggable="taggable"
        :clearable="clearable"
        :searchable="searchable"
        :disabled="disabled"
        class="input input-block input-text-center quiz-dropdown x-select"
    >
        <template #no-options>{{ $t('sorry_no_natching_options') }}</template>
    </v-select>
</template>

<script>
export default {
    name: 'XSelect',

    props: {
        value: {},

        name: {},

        label: {
            type: String,
            default: null
        },

        placeholder: {},

        options: {
            type: Array
        },

        multiple: {},

        taggable: {
            type: Boolean,
            default: false
        },

        clearable: {
            type: Boolean,
            default: true
        },

        searchable: {
            type: Boolean,
            default: true
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        input(val) {
            this.$emit('input', val)
        }
    }
}
</script>

<style lang="scss">
.x-select {
    .vs__dropdown-toggle {
        height: 100%;

        .vs__selected-options {
            column-gap: 0.5rem;
            padding-left: 0.5rem;
        }
    }
}
</style>
